import axios from '../Axios';

class OrderService {
  async getOrders(filters = {}, page = 1, perPage = 10) {
    try {
      const response = await axios.get('/admin/order', {
        params: {
          ...filters,
          page,
          per_page: perPage,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Failed to fetch Orders:", error);
      throw error;
    }
  }

  async getOrder(id) {
    try {
      const response = await axios.get(`/admin/order/${id}`);
      console.log("Fetched order:", response);
      return response.data.data;
    } catch (error) {
      console.error("Failed to fetch order:", error);
      throw error;
    }
  }

  async updateOrder(id, data) {
    try {
      const response = await axios.put(`/admin/order/${id}`, data);
      return response.data.data;
    } catch (error) {
      console.error("Failed to update order:", error);
      throw error;
    }
  }

  async markAsPrinted(ids) {
    try {
      const response = await axios.post('/admin/order/mark-printed', { ids });
      return response.data;
    } catch (error) {
      console.error("Failed to mark orders as printed:", error);
      throw error;
    }
  }

  async exportOrders(filters = {}) {
    try {
      const response = await axios.get('/admin/order/export', {
        params: filters,
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      console.error("Failed to export orders:", error);
      throw error;
    }
  }

  async scanTracking(trackingNumber) {
    try {
      const response = await axios.post('/admin/order/scan-tracking', { tracking_number: trackingNumber });
      return response.data.data;
    } catch (error) {
      console.error('Failed to process scanned tracking number:', error);
      throw error;
    }
  }

  async printBostaWaybill(orderIds) {
    try {
      // Raw PDF body on success, not JSON - see OrderService::printBostaWaybills().
      const response = await axios.get('/admin/order/print-waybill', {
        params: { order_ids: orderIds },
        responseType: 'blob',
      });

      const skippedHeader = response.headers['x-skipped-orders'] || '';

      return {
        blob: response.data,
        skippedOrderNumbers: skippedHeader ? skippedHeader.split(',').filter(Boolean) : [],
      };
    } catch (error) {
      // An error response is still JSON, but responseType: 'blob' means axios
      // hands it back as an unparsed Blob rather than the usual object - has
      // to be read back out as text and parsed before error.response.data.message
      // means anything.
      if (error.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          error.response.data = JSON.parse(text);
        } catch {
          // leave error.response.data as the raw Blob if it wasn't JSON either
        }
      }
      throw error;
    }
  }

  async exportOrdersByDateRange(dateFrom, dateTo) {
    try {
      return await axios.get('/admin/order/export/date-range', {
        params: {
          date_from: dateFrom,
          date_to: dateTo,
        },
        responseType: 'blob',
      });
    } catch (error) {
      console.error('Failed to export orders by date range:', error);
      throw error;
    }
  }

  // Places an order exactly the way a real guest checkout would - cash on
  // delivery only, server-enforced (see CreateGuestOrderService, which
  // never reads payment_method from the request at all).
  async createGuestOrder(data) {
    try {
      const response = await axios.post('/admin/order/create-guest', data);
      return response.data.data;
    } catch (error) {
      console.error('Failed to create order:', error);
      throw error;
    }
  }
}

export default new OrderService();
